import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=79929228&"
import script from "./FormPage.vue?vue&type=script&lang=ts&"
export * from "./FormPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79929228')) {
      api.createRecord('79929228', component.options)
    } else {
      api.reload('79929228', component.options)
    }
    module.hot.accept("./FormPage.vue?vue&type=template&id=79929228&", function () {
      api.rerender('79929228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchasing/goods-receipt-price/FormPage.vue"
export default component.exports